import { render, staticRenderFns } from "./sort-badge.vue?vue&type=template&id=9915db46&scoped=true&"
import script from "./sort-badge.vue?vue&type=script&lang=js&"
export * from "./sort-badge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9915db46",
  null
  
)

export default component.exports